import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
  Navigate,
} from "react-router-dom";

import Question from "./pages/Question";
import Score from "./pages/Score";
import { LanguageSelectionProvider } from "./contexts/LanguageContext";
import RegistrationForm from "./pages/RegistrationForm";
import InstructionPage from "./pages/InstructionPage";
import UnauthorizedPage from "./pages/UnauthorizedMessagePage";

const root = ReactDOM.createRoot(document.getElementById("root"));

function AppRoutes() {
  const location = useLocation();

  const search = location.search;

  const templateCode = new URLSearchParams(search).get("template_code");

  return (
    <Routes>
      <Route
        path="/"
        element={
          <Navigate
            to={`/user-registration?template_code=${templateCode}`}
            replace
          />
        }
      />

      <Route
        path="/user-registration"
        element={<RegistrationForm template={templateCode} />}
      />

      <Route path="/instruction" element={<InstructionPage />} />

      <Route path="/languages" element={<App />} />

      <Route path="/questions/:id/:tempCode" element={<Question />} />

      <Route path="/score/:id/:tempCode" element={<Score />} />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />
    </Routes>
  );
}

root.render(
  <LanguageSelectionProvider>
    <Router>
      <AppRoutes />
    </Router>
  </LanguageSelectionProvider>,
);

reportWebVitals();
